<!-- 后台管理菜单 组件 -->
<template>
  <div class="appList">
    <userInfo />
    <!-- 
      defaultValue 默认选中 效果
      expanded // 默认展开菜单
      collapsed 收起不收起
      -->
    <!-- v-model:value="routethen" -->
    <t-menu
      theme="light"
      v-model:expanded="expanded2"
      v-model:value="routethen"
      :collapsed="collapsed"
      expand-mutex
      @change="menuchange($event)"
    >
      <!-- 搜索 -->
      <!-- <t-input
        v-model="searchQuery"
        @change="inputLis"
        class="inputT"
        placeholder="请输入菜单名称"
        clearable
      >
        <template #suffixIcon>
          <IconFont name="search" />
        </template>
      </t-input> -->

      <template v-for="item in menulist" :key="item.menuId + 'id'">
        <!-- 一级菜单 -->
        <t-menu-item
          :value="item.component"
          v-if="item.children == null||item.children.length == 0"
          :to="item.path"
        >
          <template #icon>
            <i class="iconfont ri" :class="item.icon" />
          </template>
          {{ item.menuName }}
        </t-menu-item>
        <!-- 二级菜单 -->
        <t-submenu :title="item.menuName" :value="item.component" v-else>
          <template #icon>
            <i class="iconfont ri" :class="item.icon" />
          </template>
          <t-menu-item
            v-for="sonmenu in item.children"
            :key="sonmenu.path + 'path'"
            :value="sonmenu.component"
            :to="sonmenu.path"
            >{{ sonmenu.menuName }}</t-menu-item
          >
        </t-submenu>
      </template>
      <Empty
        v-if="menulist.length == 0"
        :imgRequire="require('@/assets/Frame113160.png')"
        height="90%"
        >{{$t('Nopermission')}}</Empty
      >
      <Empty v-if="menulist.length == 0" height="90%">{{$t('NoData')}}</Empty>
    </t-menu>
    <!-- 收起 -->
    <div class="sq" @click.native="changecollapsed" v-if="false">
      <t-icon v-show="collapsed" name="chevron-right" size="16" />
      <t-icon v-show="!collapsed" name="chevron-left" size="16" />
    </div>
  </div>
</template>

<script lang="jsx" setup>
import { onBeforeMount, onBeforeUnmount, ref, computed, watch } from "vue";
import { TreeData } from "@/utils/DataDispose.js";
import { getRoleMenuByUserId } from "@/api/Backs/rolePermission.js";
import { useRoute } from "vue-router";
import { debounce } from "lodash";
import { resetSetItem } from "@/utils/Session.js";
import Empty from "@/components/empty/empty";
import Cookies from "js-cookie";
import userInfo from "../userInfo";

const route = useRoute();
const menulist = ref([]);
const expanded2 = ref(['']);


function findMenuNameByPath(targetPath) {
  console.log('-----',menulist.value, targetPath)
  for (const item of menulist.value) {
    if (item.children && item.children.length > 0) {
      for (const child of item.children) {
        if (child.component === targetPath) {
          return [item.parentId,item.component]
        }
      }
    }
  }
  return null; // 如果未找到，则返回 null
};
const menufilter = () => {
  expanded2.value = [];
  expanded2.value = findMenuNameByPath(route.meta.affiliation_Left);
}

// 获取路由meta
const routethen = computed(() => {
  return route.meta.affiliation_Left;
});

// 左侧菜单切换 清楚面包屑的浏览器会话存储
function menuchange(event) {
  // console.log("event", event);
  resetSetItem("breadcrumb", JSON.stringify([]));
}

// 菜单收起
const emit = defineEmits(["debit"]);
const collapsed = ref(false);
const shouqi = debounce(changecollapsed, 300);
function changecollapsed() {
  collapsed.value = !collapsed.value;
  emit("debit", collapsed.value);
}

const Info = ref(JSON.parse(Cookies.get("userInfo")));
const Initialize = () => {
  getRoleMenuByUserId(Info.value.userId, "").then((res) => {
    if (res.code == 1) {
      menulist.value = TreeData(res.data);
      menufilter();
    }
  });
};

onBeforeMount(() => {
  Initialize();
});
</script>
<style lang="less" scoped>
@import "./index.less";
</style>
